import { useEffect, useState, useRef } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Table, Tooltip } from "antd";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import StatusTag from "../../../components/StatusTag";

const FreeTrialList = () => {
  const calledOnce = useRef(false);
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const FREE_TRIAL_LIST = () => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.free_trial_list, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.data);
        } else {
          set_page_loader(false);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
      set_page_loader(false);
    }
  };

  const CHANGE_COMPANY_STATUS_API = (company_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("company_id", company_id);
      post(ApiURL.change_trial_status, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Success", res?.message);
          FREE_TRIAL_LIST();
        } else {
          ErrorToast("Error", res?.message);
        }
      });
    } catch (error) {
      console.error("Error changing company status:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (!calledOnce.current) {
      FREE_TRIAL_LIST();
      calledOnce.current = true;
    }
  }, []);

  const columns = [
    {
      title: "Company Name",
      dataIndex: "company_name",
      align: "center",
      key: "company_name",
    },
    {
      title: "Email",
      dataIndex: "company_email",
      align: "center",
      key: "company_email",
    },
  
    {
      title: "Country",
      dataIndex: "country",
      align: "center",
      key: "country",
    },
   
    {
      title: "Demo Status",
      dataIndex: "all_status",
      align: "center",
      key: "all_status",
      render: (all_status) => (
        <StatusTag status={all_status ? all_status : ""} />
      ),
    },
    {
      title: "Trial Status",
      dataIndex: "trial_status",
      align: "center",
      key: "trial_status",
      render: (trial_status) => (
        <StatusTag status={trial_status ? trial_status : ""} />
      ),
    },
    {
      title: "Trial Start At",
      dataIndex: "start_date",
      align: "center",
      key: "start_date",
      render: (text, record) => new Date(record?.start_date).toLocaleString(),
    },
    {
      title: "Trial End At",
      dataIndex: "end_date",
      align: "center",
      key: "end_date",
      render: (text, record) => new Date(record?.end_date).toLocaleString(),
    },
    {
      title: "Action",
      align: "center",
      key: "action",
      render: (text, record) => (
        <Popconfirm
          title="Change Status"
          description={`Has the demo for "${record.company_name}" been completed?`}
          onConfirm={() => CHANGE_COMPANY_STATUS_API(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Tooltip title="Change Status">
            <Button
              type="primary"
              size="small"
              icon={<CheckCircleOutlined />}
            />
          </Tooltip>
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <div>
        <div className="row" style={{ padding: "10px" }}>
          <div
            className="col-3"
            style={{ marginLeft: "5px", alignSelf: "end" }}
          >
            <div className="theme-content-title text-left">
              <h3>Free Trial List</h3>
            </div>
          </div>
          <div className="col-3"></div>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          loading={page_loader}
          className="custom-table"
        />
      </div>
    </>
  );
};

export default FreeTrialList;
